import ReactMarkdown from "react-markdown";

const C = {
  h1: (p) => <h3 className="font-display font-bold text-base mt-3 mb-1" {...p} />,
  h2: (p) => <h4 className="font-display font-bold text-sm mt-3 mb-1 text-amber-700 dark:text-amber-400" {...p} />,
  h3: (p) => <h5 className="font-semibold text-sm mt-2 mb-1" {...p} />,
  p: (p) => <p className="mb-2 leading-relaxed" {...p} />,
  ul: (p) => <ul className="list-disc pl-5 mb-2 space-y-1" {...p} />,
  ol: (p) => <ol className="list-decimal pl-5 mb-2 space-y-1" {...p} />,
  strong: (p) => <strong className="font-semibold text-foreground" {...p} />,
};

export function Markdown({ children }) {
  return <ReactMarkdown components={C}>{children || ""}</ReactMarkdown>;
}
